import styles from './Vote.module.scss';
import {Fancybox} from '../../components';
import { useCookies } from 'react-cookie';
import cn from 'classnames';

export const Vote = ({text, desc, handler, id, iblock, status}) => {
    const [cookies, setCookie] = useCookies(['voting']);

    const showModal = (e, id) => {
        handler('closed');
        return false;

        if (!cookies.voting) {
            const elem = e.currentTarget;
            const result = {
                LINK: new Date().getTime(),
                IBLOCK: id
            }

            const queryString = Object.entries(result).map(([key, value]) => {
                return `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
            }).join('&');

            fetch("/action/kaspersky_vs_cybercringe/result-ajax.php", {
                method: "post",
                headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                body: queryString
            }).then(function(response) {
                return response.json();
            }).then(function(data) {
                if (data.result && !data.error) {
                    setCookie('voting', id, { path: '/', 'maxAge': 31104000});
                    handler('success');
                    elem.parentElement.parentElement.classList.add(styles.active);
                } else {
                    handler('error');
                }
            }).catch(function(error) {
                handler('error');
            });
        } else {
            handler('retry');
        }
    }

    const imagesList = [1,2,3].map(item => {
        return (
            <img data-fancybox={`gallery-${id}`} data-src={`${process.env.PUBLIC_URL}/elements/${id}/${item}.jpg`}
                 className={styles.item}
                 src={`${process.env.PUBLIC_URL}/elements/${id}/${item}.jpg`}
                 alt={`Участник №${id}`}
                 key={item} />
        )
    })

    return (
        <li className={cn(styles.vote, status ? styles.active : '')} key={id}>
            <div className={styles.wrapper}>
                <div className={styles.func}>
                    <div className={styles.name}>{text}</div>
                </div>
                <div className={styles.button}
                     onClick={(e) => showModal(e, iblock)}
                />
            </div>
            <div className={cn(styles.description, styles.active)}>
                {desc}
            </div>
            <div className={styles.slider}>
                <Fancybox>
                    {imagesList}
                </Fancybox>
            </div>
        </li>
    )
}